import Box from '@material-ui/core/Box';
import { KeyboardArrowDownOutlined } from '@material-ui/icons';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { FlexBox } from 'component/customize_style_component/styled_box';
import { TextErr } from 'component/customize_style_component/styled_title';
import InfoFieldItem from 'component/info_field_item';
import { StandardDatePickerFieldStyle } from 'containers/quiz_manager/my_birthday/DatePickerStyled';
import { format } from 'date-fns';
import { useState } from 'react';
export interface ICustomeDatePickerProps {
    value: any;
    setValue: (value) => void;
    setError: (error: string) => void;
    error: string | null;
    isDisabled: boolean;
    label?: string;
    userName?: string;
}

export default function CustomeDatePicker(props: ICustomeDatePickerProps) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
                className="custome-date-picker"
                textAlign={'left'}
                width="100%"
                position={'relative'}
                marginTop={'10px'}
            >
                <Box style={{ cursor: 'pointer' }} width="100%" position="absolute" top={'-10px'} left={0}>
                    <FlexBox
                        position="relative"
                        flexdirection={'column'}
                        margin={'0 0 10px 0'}
                        onClick={() => (props.isDisabled ? null : setIsOpen(!isOpen))}
                    >
                        <InfoFieldItem
                            labelClassName="birthday-label"
                            contentClassName="birthday-content"
                            label={'Birthday'}
                            opacity={props?.value ? 1 : 0.5}
                            content={
                                props?.value
                                    ? format(new Date(props?.value), 'd LLLL yyyy')
                                    : 'Please select your birthday'
                            }
                        />
                        <KeyboardArrowDownOutlined style={{ position: 'absolute', right: 0, bottom: 5 }} />
                    </FlexBox>
                </Box>
                <DesktopDatePicker
                    label={props.label || 'Select Date'}
                    value={props.value}
                    onChange={(newValue) => {
                        props.setError('');
                        props.setValue(newValue);
                        setIsOpen(false);
                    }}
                    onError={(error) => {
                        error ? props.setError('Invalid date input. Please try again.') : props.setError('');
                    }}
                    disabled={props.isDisabled}
                    disableFuture={true}
                    components={{
                        OpenPickerIcon: KeyboardArrowDownOutlined,
                        SwitchViewIcon: KeyboardArrowDownOutlined,
                    }}
                    open={isOpen}
                    renderInput={(params) => (
                        <StandardDatePickerFieldStyle
                            style={{ width: '100%', visibility: 'hidden' }}
                            variant="standard"
                            {...params}
                        />
                    )}
                    closeOnSelect={true}
                />

                {props.error && Boolean(!props?.userName) && (
                    <TextErr style={{ display: 'block' }}>{props.error}</TextErr>
                )}
            </Box>
        </LocalizationProvider>
    );
}
